const GA_ID_RE = /^(G|GTM|UA)-[A-Z0-9-]+$/i;

let injectedId = '';

function isGtm(id) {
  return /^GTM-[A-Z0-9]+$/i.test(id);
}

function injectGtag(id) {
  const src = document.createElement('script');
  src.async = true;
  src.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  src.dataset.mvGa = id;
  document.head.appendChild(src);

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', id);
}

function injectGtm(id) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
  });

  const src = document.createElement('script');
  src.async = true;
  src.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`;
  src.dataset.mvGa = id;
  document.head.appendChild(src);
}

export function injectGoogleAnalytics(rawId) {
  const id = String(rawId || '').trim().toUpperCase();
  if (!id || !GA_ID_RE.test(id) || injectedId === id) return;
  if (document.querySelector(`script[data-mv-ga="${id}"]`)) {
    injectedId = id;
    return;
  }

  if (isGtm(id)) injectGtm(id);
  else injectGtag(id);
  injectedId = id;
}
